import { Component, OnInit, Injector, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ReportsService, Statuses } from '../../forms/reports/reports.service';

@Component({
  selector: 'ga-wo-submit-report-dialog',
  templateUrl: './ga-wo-submit-report-dialog.component.html',
  styleUrls: ['./ga-wo-submit-report-dialog.component.scss']
})
export class GaWoSubmitReportDialogComponent implements OnInit {
  data: any = {};
  service: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<GaWoSubmitReportDialogComponent>,
    injector: Injector
  ) {
    this.data = data;
    this.service = injector.get(ReportsService);
  }

  ngOnInit() {
    this.service.originalWoStatusId = this.data.woStatusId;
    this.service.setReportsFormValidators(this.data.woStatus);
  }

  onYesClick(): any {
    const formData = this.service.editForm.value;
    formData.AdditionalEmailIds = this.service.formatEmails(formData.AdditionalEmailIds);
    this.dialogRef.close(formData);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isDisabled(): boolean {
    return this.service.isSubmitDisabled();
  }
}
